import React, { useEffect, useState } from 'react';
import axios from 'axios';

const PlatformAdminShops = () => {
  const [loading, setLoading] = useState(true);
  const [result, setResult] = useState([]);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      setLoading(true);

      const res = await axios.get('/api/platform_admin/shops', {
        withCredentials: true,
      });

      if (res.data && res.data.ok) {
        setResult(Array.isArray(res.data.result) ? res.data.result : []);
      } else if (res.data && res.data.redirect) {
        window.location.href = res.data.redirect;
      }
    } catch (err) {
      if (err.response && err.response.status === 401) {
        const redirectUrl =
          err.response.data && err.response.data.redirect
            ? err.response.data.redirect
            : '/platform_admin/login';
        window.location.href = redirectUrl;
        return;
      }

      console.error('상점 목록 로드 실패:', err);
      setResult([]);
    } finally {
      setLoading(false);
    }
  };

  const handleLogout = async (e) => {
    e.preventDefault();

    try {
      const res = await axios.get('/api/platform_admin/logout', {
        withCredentials: true,
      });

      if (res.data && res.data.ok && res.data.redirect) {
        window.location.href = res.data.redirect;
        return;
      }

      window.location.href = '/platform_admin/login';
    } catch (err) {
      console.error('로그아웃 실패:', err);
      window.location.href = '/platform_admin/login';
    }
  };

  const handleStatusToggle = async (id) => {
    try {
      const res = await axios.get(`/api/platform_admin/shop_status?id=${encodeURIComponent(id)}`, {
        withCredentials: true,
      });

      if (res.data && res.data.ok && res.data.redirect) {
        window.location.href = res.data.redirect;
        return;
      }
    } catch (err) {
      if (err.response && err.response.status === 401) {
        const redirectUrl =
          err.response.data && err.response.data.redirect
            ? err.response.data.redirect
            : '/platform_admin/login';
        window.location.href = redirectUrl;
        return;
      }

      if (err.response && err.response.data && err.response.data.msg) {
        alert(err.response.data.msg);
        return;
      }

      console.error('상점 상태 변경 실패:', err);
      alert('상태 변경 중 오류가 발생했습니다.');
    }
  };

  const formatNumber = (value) => {
    return Number(value || 0).toLocaleString('ko-KR');
  };

  return (
    <div className="bg-light min-vh-100">
      <nav className="navbar navbar-dark bg-dark px-4">
        <span className="navbar-brand">플랫폼 관리자</span>
        <div>
          <a href="/platform_admin/sellers" className="btn btn-sm btn-outline-light me-2">
            셀러관리
          </a>
          <a href="/platform_admin/shops" className="btn btn-sm btn-outline-light active me-2">
            상점관리
          </a>
          <a href="/platform_admin/orders" className="btn btn-sm btn-outline-light me-2">
            주문관리
          </a>
          <a href="/platform_admin/claims" className="btn btn-sm btn-outline-light me-2">
            클레임
          </a>
          <a href="/platform_admin/notices" className="btn btn-sm btn-outline-light me-2">
            공지관리
          </a>
          <a href="/platform_admin/logout" onClick={handleLogout} className="btn btn-sm btn-danger">
            로그아웃
          </a>
        </div>
      </nav>

      <div className="container my-4">
        <h4 className="mb-3">🏪 전체 상점 목록</h4>

        <div className="card shadow-sm">
          <div className="card-body p-0">
            <table className="table table-hover mb-0 align-middle">
              <thead className="table-light">
                <tr>
                  <th>ID</th>
                  <th>상점명</th>
                  <th>소유자</th>
                  <th className="text-center">상품</th>
                  <th className="text-center">주문</th>
                  <th className="text-end">매출</th>
                  <th className="text-center">상태</th>
                  <th className="text-center">관리</th>
                </tr>
              </thead>
              <tbody>
                {loading ? (
                  <tr>
                    <td colSpan="8" className="text-center py-4">
                      불러오는 중...
                    </td>
                  </tr>
                ) : result.length === 0 ? (
                  <tr>
                    <td colSpan="8" className="text-center py-4">
                      등록된 상점이 없습니다.
                    </td>
                  </tr>
                ) : (
                  result.map((row) => (
                    <tr key={row.id}>
                      <td>{row.id}</td>
                      <td>
                        <a href={`/platform_admin/shop_view?id=${row.id}`}>
                          {row.name}
                        </a>
                      </td>
                      <td>{row.owner_id}</td>
                      <td className="text-center">{formatNumber(row.product_count)}</td>
                      <td className="text-center">{formatNumber(row.order_count)}</td>
                      <td className="text-end">{formatNumber(row.total_sales)}원</td>
                      <td className="text-center">
                        {row.status === 'active' ? (
                          <span className="badge bg-success">활성</span>
                        ) : (
                          <span className="badge bg-secondary">정지</span>
                        )}
                      </td>
                      <td className="text-center">
                        <a
                          href={`/platform_admin/shop_view?id=${row.id}`}
                          className="btn btn-sm btn-outline-primary me-2"
                        >
                          보기
                        </a>
                        <button
                          type="button"
                          className="btn btn-sm btn-outline-warning"
                          onClick={() => handleStatusToggle(row.id)}
                        >
                          상태
                        </button>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PlatformAdminShops;